import Moment from 'moment';
import find from 'lodash/find';

import isEmpty from '../../../common/lib/IsEmpty';

import {
  formatRelativeDate,
  formatAnchorDate,
} from '../../../common/lib/formatSaveRDAT';
import { mediaTypes } from '../../../common/constants/';
import { dateYearIsReasonable } from '../../../common/lib/DateFormatting';
import {
  ANNOUNCEMENT_FIELD_ID,
  EXPIRATION_DATE_FIELD_ID,
} from '../../../common/components/RelativeDateAndTime/constants/index';
import { safetyIcons } from '../constants/index';

/**
 * [formatCategoryIds description]
 * @param  {object} selectedEventCategory - selected event categories
 * @param  {object} selectedSeasonCategory - selected season categories
 * @return {object} mode that is returned for the api call
 */
export const formatCategoryIds = ({
  selectedEventCategory,
  selectedSeasonCategory,
}) => {
  const seasonIds = selectedSeasonCategory.map((item) => item.value);
  const eventIds = selectedEventCategory.map((item) => item.value);
  const categoryIds = eventIds.concat(seasonIds);
  return categoryIds;
};

/**
 * checks if id : 0 (which referrs Safety modal Enabled itself)  element is in a list , returns object
 * with a value true if it appears and filtered array without that element .
 * @param safetyIds
 */

const checkSafetyModalEnabled = (safetyIds) => {
  let result = {
    filteredArr: [],
    safetyEnabled: false,
  };
  if (safetyIds.length > 0) {
    for (let i = 0; i < safetyIds.length; i++) {
      if (safetyIds[i].id == 0) {
        result.safetyEnabled = true;
      } else {
        result.filteredArr.push(safetyIds[i]);
      }
    }
  }
  return result;
};

/**
 * Prepares the payload for the event.
 *
 * @param p - Props
 * @param eventId
 * @param headliners
 * @param headlinerFreeForm
 * @param supportingActs
 * @param presentedBy
 * @param tourTitle
 * @param promoters
 * @param supportingActsFreeForm
 * @param doors
 * @param rdatFlag
 * @param visibleOnSites
 * @param doorPrice
 * @param isTBD
 * @param isPublicEDP
 * @param runCreateCMSEvent
 */
export const prepareEventBody = (
  p,
  eventId,
  headliners,
  headlinerFreeForm,
  supportingActs,
  presentedBy,
  tourTitle,
  promoters,
  supportingActsFreeForm,
  doors,
  rdatFlag,
  visibleOnSites,
  doorPrice,
  isTBD,
  isPublicEDP,
  runCreateCMSEvent,
  overlapEvent,
  safetyIcons,
  eventPromoter,
  shortCode
) => {
  const eventData = {};
  eventData.Name =
    p.axsVenueId && p.axsVenueId > 1 && p.axsEvent
      ? headlinerFreeForm
      : p.eventName;
  eventData.LookupId = p.eventLookupId;
  eventData.VenueId = p.venueId;
  eventData.Modified = p.modified;
  eventData.AxsManagerId = Number(p.axsManagerId) || null;
  eventData.VenueManagerId = Number(p.venueManagerId) || null;
  eventData.CategoryIds = formatCategoryIds(p);
  eventData.PriceLevelOverrideInManifest = p.priceLevelOverrideInManifest;
  eventData.PromoterId = eventPromoter ? eventPromoter : null;

  if (rdatFlag) {
    eventData.EventStartDate = formatAnchorDate(p.eventStartDate, eventId);
    eventData.OnsaleDate = formatAnchorDate(p.generalOnsaleDate, eventId);
    eventData.EventEndDate = formatRelativeDate(
      p.eventEndDate,
      p.eventStartDate,
      p.generalOnsaleDate,
      eventId
    );
    eventData.ETixDeliveryDate = formatRelativeDate(
      p.eTicketStartDate,
      p.eventStartDate,
      p.generalOnsaleDate,
      eventId
    );
    eventData.FlashDeliveryDate = formatRelativeDate(
      p.flashDeliveryStartDate,
      p.eventStartDate,
      p.generalOnsaleDate,
      eventId
    );
    eventData.StandardDelivery = formatRelativeDate(
      p.standardDeliveryDate,
      p.eventStartDate,
      p.generalOnsaleDate,
      eventId
    );
  } else {
    eventData.StartDate = p.eventStartDate.date;
    eventData.EndDate = p.eventEndDate.date;
    eventData.GeneralOnsaleDate = p.generalOnsaleDate.date;
    eventData.ETicketDeliveryDate = p.eTicketStartDate.date;
    eventData.FlashSeatsDeliveryDate = p.flashDeliveryStartDate.date;
    eventData.StandardDeliveryDate = p.standardDeliveryDate.date;
  }

  if (p.templateId) {
    eventData.TemplateId = Number(p.templateId);
  }
  if (Number(eventId) > 0) {
    eventData.Id = Number(eventId);
  }

  // CMS Update Information
  if (p.axsVenueId && p.axsVenueId > 1 && p.axsEvent && !runCreateCMSEvent) {
    let doorTime = 'null';
    let expirationDate = p.expirationDate;
    //p.expirationDate ^
    if (doors && Moment(doors.date).isValid() && !isTBD) {
      const DateTime =
        p.eventStartDate.date.split('T')[0] + 'T' + doors.date.split('T')[1];
      const FieldId = doors.fieldId;
      doorTime = Object.assign({}, { DateTime, FieldId }, { EventId: eventId });
    }
    const selectedSites = {};
    visibleOnSites.map((site) => {
      selectedSites[site.id] = site.default === 'selected';
    });

    selectedSites['999'] = isPublicEDP;

    eventData.AXSEvent = {
      EventId: p.axsEvent.eventId,
      Age: p.age,
      PublishStatus: p.publishStatus,
      StatusId: p.ticketing.statusId,
      Bio: p.axsEvent.bio,
      Description: p.axsEvent.description,
      MinorCategoryId1: p.minorCategoryId1,
      MinorCategoryId2: p.minorCategoryId2 || '',
      MinorCategoryId3: p.minorCategoryId3 || '',
      DoorDate: doorTime,
      DoorPrice: doorPrice,
      TicketPrice: formatTicketPrice(p.axsEvent.ticketPrice),
      Modified: p.axsEvent.modified,
      PresentedBy: presentedBy,
      TourTitle: tourTitle,
      OnsaleDateTime: p.axsEvent.onsaleDateTime,
      SiteData: selectedSites,
      AllowDuplicateEvents: overlapEvent,
      SafetyIcons: checkSafetyModalEnabled(safetyIcons).filteredArr,
      SafetyModalEnabled: checkSafetyModalEnabled(safetyIcons).safetyEnabled,
      ShortCodeId: Number(shortCode) || null,
    };

    if (isTBD) {
      eventData.AXSEvent.EventDateTime = 'TBD';
    }

    if (rdatFlag) {
      const AnnouncementDate = formatRelativeDate(
        p.announcementDate,
        p.eventStartDate,
        p.generalOnsaleDate,
        eventId
      );

      Object.assign(eventData.AXSEvent, { AnnouncementDate });
    } else {
      Object.assign(eventData.AXSEvent, {
        AnnounceDateTime: p.announcementDate.date,
      });
    }

    if (p.expirationDate) {
      const date =
        p.expirationDate.date === '0001-01-01T00:00:00' ||
        p.expirationDate.date === ''
          ? null
          : p.expirationDate.date;
      const ExpirationDate = {
        DateTime: date,
        FieldId: EXPIRATION_DATE_FIELD_ID,
      };
      Object.assign(eventData.AXSEvent, { ExpirationDate });
    }

    // Media
    const addMedia = {};
    if (p.media || p.axsEvent.media) {
      addMedia[mediaTypes.PRIMARY_LANDSCAPE] = setMedia(
        p.axsEvent.media,
        mediaTypes.PRIMARY_LANDSCAPE
      );
      if (p.media) {
        addMedia[mediaTypes.PRIMARY_LANDSCAPE].Media = p.media.substring(23);
      }
    }

    if (p.mediaSquare || p.axsEvent.media) {
      addMedia[mediaTypes.PRIMARY_SQUARE] = setMedia(
        p.axsEvent.media,
        mediaTypes.PRIMARY_SQUARE
      );
      if (p.mediaSquare) {
        addMedia[mediaTypes.PRIMARY_SQUARE].Media = p.mediaSquare.substring(23);
      }
    }

    if (p.mediaFacebook || p.axsEvent.media) {
      addMedia[mediaTypes.FACEBOOK] = setMedia(
        p.axsEvent.media,
        mediaTypes.FACEBOOK
      );
      if (p.mediaFacebook) {
        addMedia[mediaTypes.FACEBOOK].Media = p.mediaFacebook.substring(23);
      }
    }
    eventData.AXSEvent.Media = addMedia;
    eventData.AXSEvent.Associations = {};

    if (headliners && Array.isArray(headliners)) {
      eventData.AXSEvent.Associations.Headliners = headliners.map(
        (headliner) => {
          return { PerformerId: headliner.performerId, Name: headliner.name };
        }
      );
    }
    if (headliners && typeof headliners === 'object') {
      eventData.AXSEvent.Associations.Headliners = Object.keys(headliners).map(
        (key) => {
          return {
            PerformerId: headliners[key].performerId,
            Name: headliners[key].name,
          };
        }
      );
    }
    if (supportingActs && Array.isArray(supportingActs)) {
      eventData.AXSEvent.Associations.SupportingActs = supportingActs.map(
        (supportingAct) => {
          return {
            PerformerId: supportingAct.performerId,
            Name: supportingAct.name,
          };
        }
      );
      eventData.AXSEvent.Title = {
        SupportingText: supportingActsFreeForm,
      };
    }
    if (supportingActs && typeof supportingActs === 'object') {
      eventData.AXSEvent.Associations.SupportingActs = Object.keys(
        supportingActs
      ).map((key) => {
        return {
          PerformerId: supportingActs[key].performerId,
          Name: supportingActs[key].name,
        };
      });
      eventData.AXSEvent.Title = {
        SupportingText: supportingActsFreeForm,
      };
    }
    if (promoters) {
      eventData.AXSEvent.Promoters = promoters.map((promoter) => {
        return {
          PromoterId: promoter.promoterId,
          PromoterName: promoter.promoterName,
        };
      });
    }
  }
  return eventData;
};

/**
 * Prepares the payload for CMS creation.
 *
 * @param p - Props
 * @param eventId
 * @param headliners
 * @param supportingActs
 * @param presentedBy
 * @param tourTitle
 * @param promoters
 * @param supportingActsFreeForm
 * @param doors
 * @param rdatFlag
 * @param visibleOnSites
 * @param doorPrice
 * @param isTBD
 * @param isPublicEDP
 */

export const prepareCMSBody = (
  p,
  eventId,
  headliners,
  supportingActs,
  presentedBy,
  tourTitle,
  promoters,
  supportingActsFreeForm,
  doors,
  rdatFlag,
  visibleOnSites,
  doorPrice,
  isTBD,
  isPublicEDP,
  cmsOverlap,
  safetyIcons
) => {
  const CMSBody = {};
  CMSBody.LookupId = p.eventLookupId;
  CMSBody.VenueId = p.venueId;
  if (Number(eventId) > 0) {
    CMSBody.EventId = Number(eventId);
  }

  // CMS Update Information
  if (p.axsVenueId && p.axsVenueId > 1 && p.axsEvent) {
    let doorTime = 'null';
    if (doors && Moment(doors.date).isValid() && !isTBD) {
      const DateTime =
        p.eventStartDate.date.split('T')[0] + 'T' + doors.date.split('T')[1];
      const FieldId = doors.fieldId;
      doorTime = Object.assign({}, { DateTime, FieldId }, { EventId: eventId });
    }
    const selectedSites = {};
    visibleOnSites.map((site) => {
      selectedSites[site.id] = site.default === 'selected';
    });

    selectedSites['999'] = isPublicEDP;

    CMSBody.AXSEvent = {
      EventId: p.axsEvent.eventId,
      Age: p.age,
      PublishStatus: p.publishStatus,
      StatusId: p.ticketing.statusId,
      Bio: p.axsEvent.bio,
      Description: p.axsEvent.description,
      MinorCategoryId1: p.minorCategoryId1,
      MinorCategoryId2: p.minorCategoryId2 || '',
      MinorCategoryId3: p.minorCategoryId3 || '',
      DoorDate: doorTime,
      DoorPrice: doorPrice,
      TicketPrice: formatTicketPrice(p.axsEvent.ticketPrice),
      Modified: p.axsEvent.modified,
      PresentedBy: presentedBy,
      TourTitle: tourTitle,
      OnsaleDateTime: p.axsEvent.onsaleDateTime,
      SiteData: selectedSites,
      AllowDuplicateEvents: cmsOverlap,
      SafetyIcons: checkSafetyModalEnabled(safetyIcons).filteredArr,
      SafetyModalEnabled: checkSafetyModalEnabled(safetyIcons).safetyEnabled,
    };

    if (isTBD) {
      CMSBody.AXSEvent.EventDateTime = 'TBD';
    } else if (p.axsEvent.eventDateTime) {
      CMSBody.AXSEvent.EventDateTime = p.axsEvent.eventDateTime;
    } else {
      CMSBody.AXSEvent.EventDateTime = p.eventStartDate.date;
    }

    if (rdatFlag) {
      const AnnouncementDate = formatRelativeDate(
        p.announcementDate,
        p.eventStartDate,
        p.generalOnsaleDate,
        eventId
      );

      Object.assign(CMSBody.AXSEvent, { AnnouncementDate });
    } else {
      Object.assign(CMSBody.AXSEvent, {
        AnnounceDateTime: p.announcementDate.date,
      });
    }
    if (p.expirationDate) {
      const date =
        p.expirationDate.date === '0001-01-01T00:00:00' ||
        p.expirationDate.date === ''
          ? null
          : p.expirationDate.date;
      const ExpirationDate = {
        DateTime: date,
        FieldId: EXPIRATION_DATE_FIELD_ID,
      };
      Object.assign(CMSBody.AXSEvent, { ExpirationDate });
    }

    // Media
    const addMedia = {};
    if (p.media || p.axsEvent.media) {
      addMedia[mediaTypes.PRIMARY_LANDSCAPE] = setMedia(
        p.axsEvent.media,
        mediaTypes.PRIMARY_LANDSCAPE
      );
      if (p.media) {
        addMedia[mediaTypes.PRIMARY_LANDSCAPE].Media = p.media.substring(23);
      }
    }

    if (p.mediaSquare || p.axsEvent.media) {
      addMedia[mediaTypes.PRIMARY_SQUARE] = setMedia(
        p.axsEvent.media,
        mediaTypes.PRIMARY_SQUARE
      );
      if (p.mediaSquare) {
        addMedia[mediaTypes.PRIMARY_SQUARE].Media = p.mediaSquare.substring(23);
      }
    }

    if (p.mediaFacebook || p.axsEvent.media) {
      addMedia[mediaTypes.FACEBOOK] = setMedia(
        p.axsEvent.media,
        mediaTypes.FACEBOOK
      );
      if (p.mediaFacebook) {
        addMedia[mediaTypes.FACEBOOK].Media = p.mediaFacebook.substring(23);
      }
    }
    CMSBody.AXSEvent.Media = addMedia;
    CMSBody.AXSEvent.Associations = {};

    if (headliners && Array.isArray(headliners)) {
      CMSBody.AXSEvent.Associations.Headliners = headliners.map((headliner) => {
        return { PerformerId: headliner.performerId, Name: headliner.name };
      });
    }
    if (headliners && typeof headliners === 'object') {
      CMSBody.AXSEvent.Associations.Headliners = Object.keys(headliners).map(
        (key) => {
          return {
            PerformerId: headliners[key].performerId,
            Name: headliners[key].name,
          };
        }
      );
    }
    if (supportingActs && Array.isArray(supportingActs)) {
      CMSBody.AXSEvent.Associations.SupportingActs = supportingActs.map(
        (supportingAct) => {
          return {
            PerformerId: supportingAct.performerId,
            Name: supportingAct.name,
          };
        }
      );
      CMSBody.AXSEvent.Title = {
        SupportingText: supportingActsFreeForm,
        Headliners: p.eventName,
      };
    }
    if (supportingActs && typeof supportingActs === 'object') {
      CMSBody.AXSEvent.Associations.SupportingActs = Object.keys(
        supportingActs
      ).map((key) => {
        return {
          PerformerId: supportingActs[key].performerId,
          Name: supportingActs[key].name,
        };
      });
      CMSBody.AXSEvent.Title = {
        SupportingText: supportingActsFreeForm,
        Headliners: p.eventName,
      };
    }
    if (promoters) {
      CMSBody.AXSEvent.Promoters = promoters.map((promoter) => {
        return {
          PromoterId: promoter.promoterId,
          PromoterName: promoter.promoterName,
        };
      });
    }
  }
  return CMSBody;
};

/**
 * Format door price properly to not cause CMS event failure
 * @param axsEvent
 * @returns {string|null|string|*}
 */
export const formatDoorPrice = (axsEvent) => {
  let doorPrice = null;
  const doorPriceObject = axsEvent && axsEvent.doorPrice;
  if (!axsEvent) {
    doorPrice = '';
    return doorPrice;
  }
  if (typeof axsEvent.doorPrice === 'object') {
    const doorPriceValues = Object.values(axsEvent.doorPrice)
      .filter((price) => {
        if (price.trim() !== '') {
          return price;
        }
      })
      .map((v) => v.trim());
    if (!doorPriceValues.length) {
      doorPrice = '';
      return doorPrice;
    }
    if (doorPriceValues.length === 1 && doorPriceObject.low.trim()) {
      doorPrice = `${doorPriceValues[0].trim()} -`;
      return doorPrice;
    }
    if (doorPriceValues.length === 1 && doorPriceObject.high.trim()) {
      doorPrice = `- ${doorPriceValues[0].trim()}`;
    }
    if (doorPriceValues.length === 2) {
      doorPrice = `${doorPriceValues[0]}-${doorPriceValues[1]}`;
      return doorPrice;
    }
  } else if (typeof axsEvent.doorPrice === 'string') {
    if (axsEvent.doorPrice === '-') {
      doorPrice = null;
      return doorPrice;
    } else {
      doorPrice = axsEvent.doorPrice;
      return doorPrice;
    }
  }
  return doorPrice;
};

/**
 * Format ticket price properly to not cause CMS event failure
 * @param ticketPrice
 * @returns {string|null|string|*}
 */
export function formatTicketPrice(ticketPrice) {
  let _ticketPrice = null;

  if (!ticketPrice) {
    _ticketPrice = '';
    return _ticketPrice;
  }
  if (typeof ticketPrice === 'string') {
    const ticketPriceValues = ticketPrice.split('-').map((p) => p.trim());

    if (!ticketPriceValues.length) {
      _ticketPrice = '';
      return _ticketPrice;
    }
    if (
      ticketPriceValues.length === 2 &&
      ticketPriceValues[0] &&
      !ticketPriceValues[1]
    ) {
      _ticketPrice = `${ticketPriceValues[0]} - `;
      return _ticketPrice;
    }
    if (
      ticketPriceValues.length === 2 &&
      !ticketPriceValues[0] &&
      ticketPriceValues[1]
    ) {
      _ticketPrice = ` - ${ticketPriceValues[1]}`;
      return _ticketPrice;
    }
    if (ticketPriceValues.length === 2) {
      _ticketPrice = `${ticketPriceValues[0]} - ${ticketPriceValues[1]}`;
      return _ticketPrice;
    }
    if (ticketPrice.trim() === '-') {
      _ticketPrice = null;
      return _ticketPrice;
    } else {
      _ticketPrice = ticketPrice;
      return _ticketPrice;
    }
  }
  return ticketPrice;
}

/**
 * Validates the CMS payload.
 *
 * @param p - Props
 * @param errors
 * @param setError
 * @param {Boolean} runCreateCMSEvent - if user has enabled to create a CMS event from a BO/ET only event
 * @returns {*}
 */
export const validateCMS = (p, errors, setError, runCreateCMSEvent) => {
  if ((p.axsVenueId && p.axsVenueId > 1 && p.axsEvent) || runCreateCMSEvent) {
    if (p.ticketing ? !p.ticketing.statusId : true) {
      setError('eventStatusId', true, 'The Event Status is required.');
      errors = true;
    } else {
      setError('eventStatusId', false, '');
    }

    if (!p.majorCategoryId1) {
      setError(
        'majorCategoryId',
        true,
        'The Event must have at least 1 Genre defined.'
      );
      errors = true;
    } else {
      setError('majorCategoryId', false, '');
    }

    if (!p.majorCategoryId1) {
      setError(
        'majorCategoryId',
        true,
        'The Event must have at least 1 Genre defined.'
      );
      errors = true;
    } else {
      setError('majorCategoryId', false, '');
    }
    if (
      p.axsEvent &&
      p.announcementDate.date &&
      !dateYearIsReasonable(Moment(p.announcementDate.date))
    ) {
      setError(
        'announcementDate',
        true,
        'Announcement Date must have a valid year (within the last decade or forward).'
      );
      errors = true;
    } else if (p.axsEvent && !p.announcementDate.date) {
      setError('announcementDate', true, 'Announcement Date is required.');
      errors = true;
    } else {
      setError('announcementDate', false, '');
    }
  }
  return errors;
};

/**
 * When new offer names contain a hyphen, we prefix with the event name.
 *
 * @param offerName
 * @param eventName
 * @returns String
 */
export const formatNewOfferName = (offerName, eventName) => {
  const nameParts = offerName.split('-');
  return nameParts.length < 2
    ? eventName
    : `${eventName} - ${nameParts[nameParts.length - 1]}`;
};

export const getInitialState = (props) => {
  const isEditing = Number(props.params.id) > 0;
  return {
    flashDate: props.flashDeliveryStartDate,
    eTicketDate: props.eTicketStartDate,
    standardDeliveryDate: props.standardDeliveryDate,
    originalLookupId: props.eventLookupId,
    lookupIdOverridden: isEditing,
    formIsValid: isEditing,
    formIsComplete: isEditing,
    errors: {
      eTicketDate: false,
      eTicketDateMessage: '',
      eventStatusId: false,
      eventStatusIdMessage: '',
      majorCategoryId: false,
      majorCategoryIdMessage: '',
      eventStartDate: false,
      eventStartMessage: '',
      eventEndDate: false,
      eventEndDateMessage: '',
      eventName: false,
      eventNameMessage: '',
      flashDate: false,
      flashDateMessage: '',
      standardDeliveryDate: false,
      standardDeliveryMessage: '',
      generalOnSaleDate: '',
      announcementDate: false,
      announcementDateMessage: '',
      expirationDate: false,
      expirationDateMessage: '',
      lookupId: false,
      lookupIdMessage: '',
      eventCategory: false,
      eventCategoryMessage: '',
      seasonCategory: false,
      seasonCategoryMessage: '',
    },
    completed: {
      eTicketDate: isEditing,
      eventStartDate: isEditing,
      eventEndDate: isEditing,
      eventName: isEditing,
      flashDate: isEditing,
      standardDeliveryDate: isEditing,
    },
    isTBD: props.axsEvent && props.axsEvent.eventDateTime === 'TBD',
    isLoading: false,
    isPromotersLoading: false,
    isSaveInProgress: false,
    priceLevelOverrideInManifest: props.priceLevelOverrideInManifest || true,
    presentedBy: '',
    headlinerFreeForm: props.eventName || '',
    supportingActsFreeForm: props.supportingActsFreeForm || '',
    canCreateCMSEvent: !(
      props.axsVenueId &&
      props.axsVenueId > 1 &&
      props.axsEvent &&
      Object.keys(props.axsEvent.ticketing).length
    ),
    isCreatingCMSEvent: false,
    cmsOverlap: false,
    eventOverlap: false,
    expirationDate:
      props.axsEvent && props.axsEvent.expirationDateTime
        ? props.axsEvent.expirationDateTime
        : '',
    safetyIconsIds: setSafetyIcons(props.axsEvent),
  };
};

const setSafetyIcons = (axsEvent) => {
  let newSafetyIcons = [];
  if (axsEvent && axsEvent.safetyIcons) {
    newSafetyIcons = [...axsEvent.safetyIcons];
  }
  if (axsEvent && axsEvent.safetyModalEnabled) {
    newSafetyIcons.push({ id: safetyIcons[0].id });
  }
  return newSafetyIcons;
};

/**
 * Sets the media for various media types.
 *
 * @param media
 * @param mediaType
 * @returns {*}
 */
const setMedia = (media, mediaType) => {
  if (!media) return {};
  return {
    MediaDelete: media[mediaType] && media[mediaType].mediaDelete,
    DeleteSecondary: media[mediaType] && media[mediaType].deleteSecondary,
    MediaTypeId: mediaType,
  };
};

/**
 * When removing a tag, sorts the genres based on the order that the user tagged the headliners and their genres
 * If user removes all tags the genres are reset to initial state
 * @param {Array} tags - tagged artist headliners
 * @returns {Object} - containing all major and minor tagged Genres
 */
export const sortGenres = (tags) => {
  if (!tags) return;
  let orderedGenres = {};
  let taggedGenres = {
    majorCategoryId1: [],
    majorCategoryId2: [],
    majorCategoryId3: [],
    minorCategoryId1: [],
    minorCategoryId2: [],
    minorCategoryId3: [],
  };
  tags.forEach((artist, i) => {
    if (artist.majorCategory1Id) {
      taggedGenres.majorCategoryId1.push(artist.majorCategory1Id);
      taggedGenres.minorCategoryId1.push(artist.minorCategory1Id);
    }
    if (artist.majorCategory2Id) {
      taggedGenres.majorCategoryId2.push(artist.majorCategory2Id);
      taggedGenres.minorCategoryId2.push(artist.minorCategory2Id);
    }
    if (artist.majorCategory3Id) {
      taggedGenres.majorCategoryId3.push(artist.majorCategory3Id);
      taggedGenres.minorCategoryId3.push(artist.minorCategory3Id);
    }
  });
  const hasThirdGenre =
    taggedGenres.majorCategoryId1.length +
      taggedGenres.majorCategoryId2.length >
    2;
  if (!taggedGenres.majorCategoryId2.length > 0 && tags.length > 0) {
    taggedGenres.majorCategoryId2 =
      taggedGenres.majorCategoryId1[1] ||
      taggedGenres.majorCategoryId3[0] ||
      [];
    taggedGenres.minorCategoryId2 =
      taggedGenres.minorCategoryId1[1] ||
      taggedGenres.minorCategoryId3[0] ||
      [];
  }
  if (
    !taggedGenres.majorCategoryId3.length > 0 &&
    tags.length > 0 &&
    hasThirdGenre
  ) {
    taggedGenres.majorCategoryId3 =
      taggedGenres.majorCategoryId3[0] ||
      taggedGenres.majorCategoryId1[2] || [taggedGenres.majorCategoryId1[1]] ||
      taggedGenres.majorCategoryId2[1] ||
      taggedGenres.majorCategoryId2[2] ||
      [];
    taggedGenres.minorCategoryId3 =
      taggedGenres.minorCategoryId3[0] ||
      taggedGenres.minorCategoryId1[2] || [taggedGenres.minorCategoryId1[1]] ||
      taggedGenres.minorCategoryId2[1] ||
      taggedGenres.minorCategoryId2[2] ||
      [];
  }
  Object.keys(taggedGenres).forEach((key) => {
    orderedGenres[key] =
      typeof taggedGenres[key] === 'string'
        ? taggedGenres[key]
        : taggedGenres[key][0] || null;
  });
  return { ...orderedGenres };
};

const formatOfferLookUpId = (eventLookupId, offerLookupId) => {
  let suffix = offerLookupId;
  return eventLookupId + suffix.substr(suffix.indexOf('_'));
};

/**
 * When we are publishing offers , we've to check if offer has ticketingType
 * and if we don't have same ticketingtype in any offer which is already added to an event
 * @param {Object} offer - offer with autopublish mode from template
 * @param {Array} evenntZones - current event zones
 * @returns {Boolean} - if offer has not any ticketing or match wasn't found returns true else false
 */

const checkTicketingType = (offer, eventZones) => {
  if (!offer.aXSPromotion || isEmpty(offer.aXSPromotion)) return true;
  else if (eventZones) {
    let foundMatch = eventZones.find((zone) => {
      return zone.offers.find((el) => {
        if (el.axsPromotion && !isEmpty(el.axsPromotion)) {
          return (
            el.axsPromotion.ticketLinkType === offer.aXSPromotion.ticketLinkType
          );
        }
      });
    });
    return !foundMatch;
  }
};

export const checkPublished = (offer, availOffers, event) => {
  const concatOffers = [...availOffers];
  if (event && event.zones) {
    event.zones.forEach((zone) => {
      zone.offers.forEach((offer) => {
        offer.zoneDescription = zone.description;
        offer.zoneId = zone.id;
        concatOffers.push(offer);
      });
    });
  }
  const modifiedLookUpId = formatOfferLookUpId(event.lookupId, offer.lookupId);
  return !find(concatOffers, { lookupId: modifiedLookUpId });
};

/**
 * When user clicks auto publish button in add offers section of an event
 * before sending data it needs to be formatted where this function helps
 * @param {Array} eventOffers - list of event offers
 * @param {Array} templateOffers - list of template offers
 * @param {Object} event - event data on which offers are assigned
 * @returns {Array} - array of formatted auto publish offers
 */

export const autoPublishFormat = (eventOffers, templateOffers, event) => {
  let result = [];
  const autoModeOffers = eventOffers.map((offer) => {
    const foundSelectable = find(templateOffers, { id: offer.id });
    const notRepeatedTicketing = checkTicketingType(offer, event.zones);
    const checkAlreadyPublished = checkPublished(offer, templateOffers, event);
    if (
      foundSelectable &&
      foundSelectable.isAutoPublish &&
      notRepeatedTicketing &&
      checkAlreadyPublished
    ) {
      return {
        ...offer,
        isAutoPublish: foundSelectable.isAutoPublish,
      };
    } else return false;
  });

  autoModeOffers
    .filter((el) => el)
    .forEach((offer) => {
      let indx = result.findIndex((el) => el.id === offer.zoneId);
      offer.lookupId = formatOfferLookUpId(event.lookupId, offer.lookupId);
      offer.onSaleDate =
        event.dates.generalOnsaleDate && event.dates.generalOnsaleDate.date;
      offer.offSaleDate =
        event.dates.eventStartDate && event.dates.eventStartDate.date;
      offer.startDate =
        event.dates.generalOnsaleDate && event.dates.generalOnsaleDate;
      offer.endDate = event.dates.eventStartDate && event.dates.eventStartDate;
      offer.templateOfferId = offer.id;
      offer.id = 0;
      if (indx !== -1) {
        result[indx].offers.push(offer);
      } else {
        result.push({ id: offer.zoneId, offers: [offer] });
      }
    });
  return result;
};



// WEBPACK FOOTER //
// ./src/routes/EventDetails/helpers/index.js